module.exports = __webpack_public_path__ + "static/media/jefeuap.f86bf2ac.pdf";